<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать курьера</strong>
                </CCardHeader>
                <CCardBody>
                    <CourierUpsertForm
                        @success="$router.push(`/couriers`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import CourierUpsertForm from '@/components/couriers/CourierUpsertForm';

    export default {
        name: 'CourierCreate',

        components: {
            CourierUpsertForm
        },
    };
</script>
